import React, { Component } from 'react';
import getChartLine from "./getChartLine";

class ADR extends Component {

    componentDidMount() {
        const data = this.props.data.IncomeBudget || {};
        let dataY = [];
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                dataY.push({
                    title: key,
                    data: Object.entries(data[key]).map(x => Number(x[1]) || 0)
                })
            }
        }

        const defaultData = {
            id: "ADR",
            title: "Total Revenue 总收入",
            dataY
        };
        getChartLine(defaultData);
        window.addEventListener('resize', () => {
            getChartLine(defaultData, null, true);
        });
    }

    componentWillReceiveProps(nextProps) {
        const data = nextProps.data.IncomeBudget || {};
        let dataY = [];
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                dataY.push({
                    title: key,
                    data: Object.entries(data[key]).map(x => Number(x[1]) || 0)
                })
            }
        }

        const defaultData = {
            id: "ADR",
            title: "Total Revenue 总收入",
            dataY
        };
        getChartLine(defaultData, true);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', () => { });
    }

    render() {
        return (
            <div>
                <div className="total_style">Total Revenue 总收入 </div>
                <div id="ADR" style={{ height: 400, width: '100%' }} />
            </div>
        );
    }
}

export default ADR;


// WEBPACK FOOTER //
// ./src/components/BI/home/ADR.js